import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import {Observable} from 'rxjs/Observable';
import {AuthRepository} from './../repositories/auth.repository';

@Injectable()
export class AuthService {

  private loggedIn: boolean = false;

  constructor(private authRepository: AuthRepository) { }

  public getLoggedIn(): Observable<boolean> {
    return this.authRepository.getLoggedIn()
      .do((loggedIn) => {
        this.loggedIn = loggedIn;
      })
      .catch((response: Response) => {
        return Observable.of(false);
      });
  }

  public get isLoggedIn(): boolean {
    // This method is primarily for the navbar as it's complicated to work
    // with asynchronous components there. 'loggedIn' gets updated, whenever the
    // login guard checks the login status. Therefore this should be fine.
    return this.loggedIn;
  }

  public login(username: string, password: string): Observable<Response> {
    return this.authRepository.login(username, password);
  }

  public logout(): Observable<Response> {
    return this.authRepository.logout()
      .do((response) => {
        this.loggedIn = false;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/auth/services/auth.service.ts